import React, { useCallback } from 'react'
import { hooks } from '@front/volcanion'

import Callbacks from './callbacks'

const withContainer = Component => props => {
  const navigate = hooks.useNavigate()
  const version = hooks.useVersion()
  const { CLIENT_COMMERCIAL_NAME, CLIENT_CONTACT_EMAIL } = hooks.useRelayConstants(['CLIENT_COMMERCIAL_NAME', 'CLIENT_CONTACT_EMAIL'])
  const [user] = hooks.useActiveUser({ populate: ['auth', 'customerinfo', 'info'] })

  const [company_users] = hooks.useModelSearch('companyuser', 'get', {
    initial_filter: { user: user?.user_id, status: ['active'] },
    forced_filter: { user: user?.user_id, status: ['active'] },
    watchers: [user?.user_id],
  })

  const sendContactMail = useCallback(Callbacks.sendContactMailHandler(CLIENT_CONTACT_EMAIL, CLIENT_COMMERCIAL_NAME, user), [CLIENT_CONTACT_EMAIL, CLIENT_COMMERCIAL_NAME, user])

  const hasCompany = !_.isEmpty(company_users)
  const isAdmin = !_.isEmpty(_.filter(company_users, companyuser => !!companyuser.administration_level))

  const mergedProps = {
    version,
    first_name: _.get(user, 'info.first_name'),
    user_id: user?.user_id,
    hasCompany,
    isAdmin,
    navigate,
    sendContactMail
  }

  return (
    <Component {...mergedProps} {...props} />
  )
}

export default withContainer
